export enum PaymentTypes {
    CREDITCARD = 'credit_card',
    PIX = 'pix',
    BOLETO = 'boleto'    
}
   
export function getPaymentTypeText(type: PaymentTypes): string {
    switch (type) {
        case PaymentTypes.CREDITCARD:
            return 'Cartão de Crédito';
        case PaymentTypes.PIX:
            return 'Pix';
        case PaymentTypes.BOLETO:
            return 'Boleto';
        default:
            return 'Tipo de Pagamento Desconhecido';
    }
}